<template>
  <el-dialog
    title="Import Cost Centres"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-row>
      <el-col :md="24">
        <el-row :gutter="10">
          <el-input
            v-model="costCentres"
            type="textarea"
            placeholder="Cost Centres (one per line, format: name, description)"
            clearable
            :rows="20"
          />
        </el-row>
      </el-col>
    </el-row>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="importCostCentres()"
      >
        Import
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isFullscreen: false,
      costCentres: []
    }
  },
  methods: {
    importCostCentres () {
      this.isSaving = true
      const costCentresToCreate = this.costCentres.split('\n').map(line => {
        const [name, description] = line.split(',').map(part => part.trim())
        console.log({ name, description })
        return { name, description }
      })
      Promise.all(costCentresToCreate.map(costCentreData => {
        return this.$sdk.account_costcentre.create(costCentreData, builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
      }))
        .then(() => this.$message({ message: 'Successfully imported cost centres', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('saved')
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>

<style>

</style>
